/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2020-12-03 09:00:04
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import EnumItem from 'src/enums/enumItem';
export declare namespace UserConfigDOI {
    export interface RowDataI {
        id: number
        mobile: string
        organization: string
        organization_id: number
        real_name: string
        role_name: string
        sex: number
        status: number
        role_id: number
    }

    export interface QueryRowDataParamsI extends PageDo {
        organization?: Integer;
        status?: Integer;
        keyword?: string;
    }

    export interface QueryDetailResultI {
        user_id?     : Integer
        real_name    : string
        mobile       : string
        sex          : Integer
        identity_card: string
        email        : string
        organization : Integer
        role_id      : Integer
        remark       : string
        status       : Integer
        system_name  : string
        english_system_name:string
        logo_url     : string
    }

    export interface OperateParamsI {
        user_id?     : Integer
        real_name    : string
        mobile       : string
        passwords?    : string
        sex          : Integer
        identity_card: string
        email        : string
        organization : Integer
        role_id      : Integer
        remark       : string
        status       : Integer
    }
}
export default class UserConfigApi {
    /**
     * 查询列表
     * @param {UserConfigDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: UserConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<UserConfigDOI.RowDataI[]>> {
        return Api.post('/auth_login/login/user/data/other', {
            organization: -2,
            status: -2,
            ...params
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(user_id: number): Promise<Result<UserConfigDOI.QueryDetailResultI[]>> {
        return Api.post('/auth_login/id/by/user_info/query', {user_id});
    }
    /**
     * 新增
     * @param {UserConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: UserConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/auth_login/login/user/add', data);
    }

    /**
     * 修改
     * @param {UserConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: UserConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/auth_login/login/user/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(user_id: number ): Promise<Result<any>> {
        return Api.post('/auth_login/login/user/delete', {user_id});
    }

    static async queryAllOrganization(): Promise<Result<EnumItem[]>> {
        return Api.post('/auth_login/organization/all/query');
    }

    static async queryAllStation(params: {user_id: number,organization_id: number}): Promise<Result<{device_id: number,select:1|2, device_name: string}[]>> {
        return Api.post('/monitor/device/user/query',params);
    }

    static async saveOrganizationStation(user_id: number ,device_ids: number[]): Promise<Result<{device_id: number,select:1|2, device_name: string}>> {
        return Api.post('/monitor/device/user/add', {user_id,device_ids});
    }

    static async updatePassword(old_password: string ,new_password: string): Promise<Result<any>> {
        return Api.post('/auth_login/login/user/password/change', {old_password,new_password});
    }

    /**
     * 意见反馈
     */
    static async updateOpinionFeedback(feedback_content: string): Promise<Result<any>> {
        return Api.post('/auth_login/opinion/feedback', {feedback_content});
    }
    
}
